import { render, staticRenderFns } from "./app_menutablets.vue?vue&type=template&id=018e8a6e"
import script from "./app_menutablets.vue?vue&type=script&lang=js"
export * from "./app_menutablets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports